/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { convertGetConvertUnixtime } from "../../funcs/convertGetConvertUnixtime.js";
import { GetConvertUnixtimeRequest$zodSchema } from "../../models/getconvertunixtimeop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetConvertUnixtimeRequest$zodSchema,
};

export const tool$convertGetConvertUnixtime: ToolDefinition<typeof args> = {
  name: "convert-get-convert-unixtime",
  description: `时间戳转换

时间戳和日期字符串，哪个用着更顺手？别纠结了，这个接口让你轻松拥有两种格式！

## 功能概述
这是一个非常智能的转换器。你给它一个 Unix 时间戳，它还你一个人类可读的日期时间；你给它一个日期时间字符串，它还你一个 Unix 时间戳。它会自动识别你输入的是哪种格式。

## 使用须知
这个接口非常智能，能够自动识别输入格式：

- **输入时间戳**：支持10位秒级（如 \`1672531200\`）和13位毫秒级（如 \`1672531200000\`）。
- **输入日期字符串**：为了确保准确性，推荐使用 \`YYYY-MM-DD HH:mm:ss\` 标准格式（如 \`2023-01-01 08:00:00\`）。

> [!TIP]
> 无论你输入哪种格式，响应中都会同时包含标准日期字符串和秒级Unix时间戳，方便你按需取用。

## 错误处理指南
- **400 Bad Request**: 如果你提供的 \`time\` 参数既不是有效的时间戳，也不是我们支持的日期格式，就会收到这个错误。请检查你的输入值。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await convertGetConvertUnixtime(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
